module.exports = __webpack_public_path__ + "img/Warning.4d944fee.svg";